export const listLabelStyle = theme => ({
    paddingDetails: {
        paddingTop: theme.spacing(1),
        whiteSpace: 'initial',
        display:'flex'
    },
    subtitle2: {
        whiteSpace: 'initial',
        fontWeight: 500,
        display: 'block',
        float: 'left',
        width: '75px',
        textAlign: 'right',
        marginRight: '5px'
    },
})